var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 587,
    height: 731,
    viewBox: "0 0 587 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.356 0H293.915V46.2532C293.915 101.482 249.143 146.253 193.915 146.253H147.356V0Z",
    fill: "#5DCC97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.57 584.747H440.129V631C440.129 686.228 395.357 731 340.129 731H293.57V584.747Z",
    fill: "#5DCC97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.355 146.253H293.797V100C293.797 44.7717 338.568 0.000228882 393.797 0.000228882H440.355V146.253Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M586.914 585.013H440.355V538.759C440.355 483.531 485.127 438.76 540.355 438.76H586.914V585.013Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.356 438.759H0.797897V392.506C0.797897 337.278 45.5694 292.506 100.798 292.506H147.356V438.759Z",
    fill: "#FFED29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.355 438.759H293.797V392.506C293.797 337.278 338.568 292.506 393.797 292.506H440.355V438.759Z",
    fill: "#5DCC97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M293.344 585.013H146.785V538.759C146.785 483.531 191.556 438.76 246.785 438.76H293.344V585.013Z",
    fill: "#5DCC97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M440.355 146.253H293.797V192.506C293.797 247.735 338.568 292.506 393.797 292.506H440.355V146.253Z",
    fill: "#FFED29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.797913 146.253H147.356V100C147.356 44.7717 102.585 0.000228882 47.3564 0.000228882H0.797913V146.253Z",
    fill: "#FFED29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 585.013H146.559V538.759C146.559 483.531 101.787 438.76 46.5585 438.76H0V585.013Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.583 731H294.141V684.747C294.141 629.518 249.37 584.747 194.141 584.747H147.583V731Z",
    fill: "#FFED29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M440.355 731H586.914V684.747C586.914 629.518 542.142 584.747 486.914 584.747H440.355V731Z",
    fill: "#3A70F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5207 322.289C87.2894 322.289 95.1041 330.383 95.1041 340.151V352.431H107.384C117.153 352.431 125.246 360.525 125.246 370.293C125.246 380.062 117.152 387.876 107.384 387.876H95.1041V400.156C95.1041 409.925 87.2894 418.018 77.5207 418.018C67.7521 418.018 59.6587 409.925 59.6587 400.156V387.876H47.3787C37.6101 387.876 29.5167 380.062 29.5167 370.293C29.5167 360.524 37.6106 352.431 47.3787 352.431H59.6587V340.151C59.6587 330.382 67.7526 322.289 77.5207 322.289Z",
    fill: "#F3DF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5207 322.289C87.2894 322.289 95.1041 330.383 95.1041 340.151V352.431H107.384C117.153 352.431 125.246 360.525 125.246 370.293C125.246 380.062 117.152 387.876 107.384 387.876H95.1041V400.156C95.1041 409.925 87.2894 418.018 77.5207 418.018C67.7521 418.018 59.6587 409.925 59.6587 400.156V387.876H47.3787C37.6101 387.876 29.5167 380.062 29.5167 370.293C29.5167 360.524 37.6106 352.431 47.3787 352.431H59.6587V340.151C59.6587 330.382 67.7526 322.289 77.5207 322.289Z",
    fill: "#F3DF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.484 167.526C383.253 167.526 391.067 175.62 391.067 185.388V197.668H403.347C413.116 197.668 421.209 205.762 421.209 215.53C421.209 225.299 413.115 233.114 403.347 233.114H391.067V245.394C391.067 255.162 383.253 263.256 373.484 263.256C363.715 263.256 355.622 255.162 355.622 245.394V233.114H343.342C333.573 233.114 325.48 225.299 325.48 215.53C325.48 205.762 333.574 197.668 343.342 197.668H355.622V185.388C355.622 175.62 363.716 167.526 373.484 167.526Z",
    fill: "#F3DF00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.484 167.526C383.253 167.526 391.067 175.62 391.067 185.388V197.668H403.347C413.116 197.668 421.209 205.762 421.209 215.53C421.209 225.299 413.115 233.114 403.347 233.114H391.067V245.394C391.067 255.162 383.253 263.256 373.484 263.256C363.715 263.256 355.622 255.162 355.622 245.394V233.114H343.342C333.573 233.114 325.48 225.299 325.48 215.53C325.48 205.762 333.574 197.668 343.342 197.668H355.622V185.388C355.622 175.62 363.716 167.526 373.484 167.526Z",
    fill: "#F3DF00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.517,
    cy: 365.633,
    rx: 73.2793,
    ry: 73.1266,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.0772,
    cy: 657.873,
    rx: 73.2793,
    ry: 73.1266,
    fill: "#3A70F6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 513.634,
    cy: 73.1266,
    rx: 73.2793,
    ry: 73.1266,
    fill: "#5DCC97"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.849,
    cy: 511.886,
    rx: 73.2793,
    ry: 73.1266,
    fill: "#FFED29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0.797913 226.028C0.797913 181.97 36.5142 146.253 80.5724 146.253H293.915V212.732C293.915 256.79 258.199 292.507 214.14 292.507H0.797913V226.028Z",
    fill: "#3A70F6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M519.927 439.104C475.869 439.104 440.153 403.388 440.153 359.33V145.987H506.632C550.69 145.987 586.406 181.704 586.406 225.762V439.104H519.927Z",
    fill: "#3A70F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.655dfabb7ff5e92ff8551eacbf52d3c1.svg";
export { ForwardRef as ReactComponent };